import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-select-item.ant-select-item-option.ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 32px;
  width: 1090px;
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;
